
import {Component, Mixins, Prop, Watch} from "vue-property-decorator";
import ObjectInputMixin from "@/mixins/ObjectInputMixin.vue";
import {IstatistikMuvekkilEntity} from "@/entity/Raporlama/IstatistikMuvekkilEntity";

@Component({})
export default class MuvekkilSecim extends Mixins(ObjectInputMixin) {

  // Props
  @Prop({ default: null }) muvekkilListFromAvukat!: Array<IstatistikMuvekkilEntity> | null;

  // UI State
  isMenuOpen: boolean = false;
  search: string = '';
  selectAll: boolean = true;

  // Data State
  items: Array<string> = [];
  allData: Array<IstatistikMuvekkilEntity> = [];
  checkedItems: { [key: string]: boolean } = {};

  // Computed
  get filteredItems(): Array<string> {
    return this.items.filter((item: string) =>
        item.toLowerCase().includes(this.search.toLowerCase())
    );
  }

  get selectedMuvIds(): Array<number> {
    const ids: Array<number> = [];
    for (const [itemName, isChecked] of Object.entries(this.checkedItems)) {
      if (isChecked) {
        const muvekkil = this.findMuvekkilByName(itemName);
        if (muvekkil?.id && !muvekkil?.kurum_id) {
          ids.push(muvekkil.id);
        }
      }
    }
    return ids;
  }

  get selectedKurumIds(): Array<number> {
    const ids: Array<number> = [];
    for (const [itemName, isChecked] of Object.entries(this.checkedItems)) {
      if (isChecked) {
        const muvekkil = this.findMuvekkilByName(itemName);
        if (muvekkil?.kurum_id && !muvekkil?.id) {
          ids.push(muvekkil.kurum_id);
        }
      }
    }
    return ids;
  }

  // Lifecycle
  mounted(): void {
    this.fetchMuvekkilList();
  }

  // Watchers
  @Watch('selectAll')
  onSelectAllChanged(value: boolean): void {
    this.setAllCheckedItems(value);
  }

  @Watch('muvekkilListFromAvukat', { immediate: false, deep: true })
  onMuvekkilListFromAvukatChanged(newList: Array<IstatistikMuvekkilEntity> | null): void {
    if (newList && newList.length > 0) {
      this.updateItemsFromAvukat(newList);
    }
  }

  // Public Methods
  handleApply(): void {
    this.isMenuOpen = false;
    this.emitSelections();
  }

  toggleItem(item: string): void {
    this.$set(this.checkedItems, item, !this.checkedItems[item]);
  }

  // Private Methods
  private async fetchMuvekkilList(): Promise<void> {
    try {
      const response: Array<IstatistikMuvekkilEntity> = await this.$http.get('/api/v1/tahsilat-muvekkil-list/');
      this.allData = response;
      this.initializeItems(response, true);
      this.emitInitialData();
    } catch (error) {
      console.error('Müvekkil listesi alınamadı:', error);
    }
  }

  private updateItemsFromAvukat(muvekkilList: Array<IstatistikMuvekkilEntity>): void {
    this.allData = muvekkilList;
    this.checkedItems = {};
    this.initializeItems(muvekkilList, true);
    this.selectAll = true;
    this.emitInitialData();
  }

  private initializeItems(muvekkilList: Array<IstatistikMuvekkilEntity>, isChecked: boolean): void {
    this.items = muvekkilList.map((muvekkil: IstatistikMuvekkilEntity) => {
      const displayName = this.getDisplayName(muvekkil);
      this.$set(this.checkedItems, displayName, isChecked);
      return displayName;
    }).filter((name): name is string => name !== undefined);
  }

  private setAllCheckedItems(value: boolean): void {
    for (const key in this.checkedItems) {
      if (Object.prototype.hasOwnProperty.call(this.checkedItems, key)) {
        this.$set(this.checkedItems, key, value);
      }
    }
  }

  private findMuvekkilByName(displayName: string): IstatistikMuvekkilEntity | undefined {
    return this.allData.find((muvekkil: IstatistikMuvekkilEntity) =>
        this.getDisplayName(muvekkil) === displayName
    );
  }

  private getDisplayName(muvekkil: IstatistikMuvekkilEntity): string | undefined {
    if (muvekkil.id && muvekkil.ad && muvekkil.soyad) {
      return `${muvekkil.ad} ${muvekkil.soyad}`;
    } else if (muvekkil.kurum_id && muvekkil.sirket_adi) {
      return muvekkil.sirket_adi;
    }
    return undefined;
  }

  private getMuvIdArray(): Array<number> {
    return this.allData
        .filter((item: IstatistikMuvekkilEntity) => item.id)
        .map((item: IstatistikMuvekkilEntity) => item.id as number);
  }

  private getKurumIdArray(): Array<number> {
    return this.allData
        .filter((item: IstatistikMuvekkilEntity) => item.kurum_id)
        .map((item: IstatistikMuvekkilEntity) => item.kurum_id as number);
  }

  private emitInitialData(): void {
    this.$emit('MuvAndKurumName', this.items);
    this.$emit('Ids', this.getMuvIdArray(), this.getKurumIdArray());
  }

  private getSelectedNames(): Array<string> {
    const names: Array<string> = [];
    for (const [itemName, isChecked] of Object.entries(this.checkedItems)) {
      if (isChecked) {
        names.push(itemName);
      }
    }
    return names;
  }

  private emitSelections(): void {
    this.$emit('selectedIds', this.selectedMuvIds, this.selectedKurumIds);
    this.$emit('MuvAndKurumName', this.getSelectedNames());
  }
}
